import { Cpu, ShieldCheck, ShieldAlert, ShieldQuestion, Radio } from "lucide-react";

// MATRIX.5 — Panneau READ-ONLY « Contrôleur de vol ». Aucune déduction frontend : toutes les
// valeurs proviennent du descriptor propagé (Agent -> Gateway -> Backend). Pas d'override admin.
const IDENTITY_UI = {
  MATCH: { label: "MATCH", color: "#22C55E", Icon: ShieldCheck, note: "Contrôleur configuré = détecté" },
  MISMATCH: { label: "MISMATCH", color: "#EF4444", Icon: ShieldAlert, note: "Contrôleur détecté ≠ configuré" },
  UNKNOWN: { label: "UNKNOWN", color: "#F59E0B", Icon: ShieldQuestion, note: "Famille contrôleur non déterminée" },
  DISCONNECTED: { label: "DISCONNECTED", color: "#525252", Icon: Radio, note: "Lien MAVLink absent" },
};

export default function FlightControllerPanel({ fc }) {
  if (!fc) {
    return (
      <div data-testid="flight-controller-panel" className="rounded-sm border border-white/10 bg-[#0F0F0F] p-3">
        <Header />
        <div data-testid="fc-no-data" className="font-mono text-[10px] text-[#737373] mt-2">
          Aucun descriptor contrôleur reçu (ancien agent ou télémétrie non propagée).
        </div>
      </div>
    );
  }
  const ui = IDENTITY_UI[fc.identity_state] || IDENTITY_UI.UNKNOWN;
  const Icon = ui.Icon;
  return (
    <div data-testid="flight-controller-panel" className="rounded-sm border border-white/10 bg-[#0F0F0F] p-3 space-y-2.5">
      <Header />
      <div data-testid="fc-identity" className="flex items-center gap-2 rounded-sm px-2.5 py-2 border"
        style={{ borderColor: ui.color + "55", background: ui.color + "14" }}>
        <Icon size={16} style={{ color: ui.color }} />
        <div className="flex-1">
          <div className="font-chivo font-bold text-xs uppercase tracking-wider" style={{ color: ui.color }}>{ui.label}</div>
          <div className="font-mono text-[9px] text-[#A3A3A3]">{ui.note}</div>
        </div>
        {fc.identity_ready === true && (
          <span data-testid="fc-identity-ready" className="font-mono text-[9px] uppercase text-[#22C55E]">prêt</span>
        )}
      </div>

      <div className="grid grid-cols-2 gap-1.5">
        <Row testid="fc-configured" label="Configuré" value={fc.configured_family} />
        <Row testid="fc-detected" label="Détecté" value={fc.detected_family} />
        <Row testid="fc-protocol" label="Protocole" value={fc.protocol} />
        <Row testid="fc-firmware" label="Firmware" value={fc.firmware_version} />
        <Row testid="fc-control-mode" label="Mode SkyCore" value={fc.control_mode} />
        <Row testid="fc-native-mode" label="Mode natif" value={fc.native_mode} />
        <Row testid="fc-external-control" label="External Control" value={boolLabel(fc.external_control_supported)} />
        <Row testid="fc-mission" label="Mission" value={boolLabel(fc.mission_supported)} />
      </div>

      <ChipList testid="fc-supported-commands" label="Commandes" items={fc.supported_commands} />
      <ChipList testid="fc-capabilities" label="Capabilities" items={fc.capabilities} />
    </div>
  );
}

function Header() {
  return (
    <div className="flex items-center gap-2">
      <Cpu size={13} className="text-[#737373]" />
      <span className="font-mono text-[10px] tracking-[0.2em] uppercase text-[#A3A3A3]">Contrôleur de vol</span>
    </div>
  );
}

function Row({ label, value, testid }) {
  return (
    <div data-testid={testid} className="flex items-center justify-between rounded-sm bg-[#141414] px-2 py-1.5">
      <span className="font-mono text-[9px] uppercase tracking-wider text-[#737373]">{label}</span>
      <span className="font-mono text-[11px] text-white">{value == null || value === "" ? "—" : String(value)}</span>
    </div>
  );
}

function ChipList({ label, items, testid }) {
  const list = Array.isArray(items) ? items : [];
  return (
    <div data-testid={testid}>
      <div className="font-mono text-[9px] uppercase tracking-wider text-[#737373] mb-1">{label}</div>
      <div className="flex flex-wrap gap-1">
        {list.length === 0 ? (
          <span className="font-mono text-[10px] text-[#525252]">—</span>
        ) : list.map((c) => (
          <span key={c} className="font-mono text-[9px] uppercase tracking-wider border border-white/15 text-[#D4D4D4] rounded-sm px-1.5 py-0.5">{c}</span>
        ))}
      </div>
    </div>
  );
}

function boolLabel(v) {
  if (v === true) return "OUI";
  if (v === false) return "NON";
  return null;
}
